import { createDirectus, rest, authentication } from "@directus/sdk";

// Resolve base URL for both Vite and Next.js runtimes
const resolveBaseUrl = () => {
  const nextUrl = typeof process !== "undefined" ? process.env?.NEXT_PUBLIC_BASE_URL : undefined;
  let viteUrl;
  try {
    // import.meta may not exist in some bundlers
    viteUrl = typeof import.meta !== "undefined" ? import.meta.env?.VITE_BASE_URL : undefined;
  } catch (_) {
    viteUrl = undefined;
  }
  const base = nextUrl || viteUrl;
  if (!base) {
    throw new Error("Directus base URL not configured. Set NEXT_PUBLIC_BASE_URL (Next.js) or VITE_BASE_URL (Vite).");
  }
  return base;
};

const client = createDirectus(resolveBaseUrl())
  .with(authentication("session", { credentials: "include", autoRefresh: true }))
  .with(rest({ credentials: "include" }));

export default client;
